module.exports = __webpack_public_path__ + "static/img/batsu-limit.6f5c98c.png";